import React from "react";
import "../styles/Planos.css";
import { X, Check } from 'lucide-react';

const Planos = () => {
  const planos = [
    {
      titulo: "Básico",
      valor: "R$ 200/mês",
      beneficios: [
        { texto: "Dashboard", ok: true },
        { texto: "1 usuário cadastrado", ok: true },
        { texto: "1 Cidade", ok: true },
        { texto: "1 Segmento", ok: true },
        { texto: "Mapa interativo", ok: true },
        { texto: "Lista de Empreendimento", ok: true },
        { texto: "Socioeconômico", ok: false },
        { texto: "Relatórios em PDF", ok: false },
        { texto: "Tabela de precificação", ok: false },
        { texto: "IA integrada", ok: false },
      ],
    },
    {
      titulo: "Profissional",
      valor: "R$ 799/mês",
      beneficios: [
        { texto: "Dashboard", ok: true },
        { texto: "1 usuário cadastrado", ok: true },
        { texto: "3 Cidade", ok: true },
        { texto: "3 Segmento", ok: true },
        { texto: "Mapa interativo", ok: true },
        { texto: "Lista de Empreendimento", ok: true },
        { texto: "Socioeconômico da cidade", ok: true },
        { texto: "Relatórios em PDF", ok: true },
        { texto: "Tabela de precificação", ok: true },
        { texto: "IA integrada", ok: false },
      ],
    },
    {
      titulo: "Premium",
      valor: "Sob consulta",
      beneficios: [
        { texto: "Dashboard", ok: true },
        { texto: "3 usuário cadastrado", ok: true },
        { texto: "Região Metropolitana", ok: true },
        { texto: "Todos os segmento", ok: true },
        { texto: "Mapa interativo", ok: true },
        { texto: "Lista de Empreendimento", ok: true },
        { texto: "Socioeconômico do Estado", ok: true },
        { texto: "Relatórios em PDF", ok: true },
        { texto: "Tabela de precificação", ok: true },
        { texto: "IA integrada", ok: true },
      ],
    },
  ];

  return (
    <section className="planos-section">
      <h2 className="planos-titulo">Nossos Planos</h2>
      <div className="planos-container">
        {planos.map((plano, index) => (
          <div key={index} className="plano-card">
            <h3 className="plano-titulo">{plano.titulo}</h3>
            <p className="plano-valor">{plano.valor}</p>
            <ul className="plano-lista">
              {plano.beneficios.map((beneficio, i) => (
                <li key={i} className="plano-item">
                  <span className={beneficio.ok ? "ok" : "nao-ok"}>
                    {beneficio.ok ? <Check/>  : <X/>}
                  </span>
                  {beneficio.texto}
                </li>
              ))}
            </ul>
            <button className="plano-botao">Entrar em contato</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Planos;
